
import { BaseService } from 'src/app/base/services/base.service';
import { Mensagem, Topico } from '../models/chat-bot.model';
import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';


@Injectable({
  providedIn: 'root'
})
export class SuporteGeralService extends BaseService<Mensagem> {

  constructor(public http: HttpClient) {
    super(http);
  }

  public sendMessage(id: number): Observable<any> {
    return this.http.post<any>(this.baseUrl + '/send-message/' + id,{}, { headers: this.headers });
  }
  public hasOpenSupport(): Observable<boolean> {
    return this.http.get<boolean>(this.baseUrl + '/has-open-supports', { headers: this.headers });
  }
  public findAllByUser(obj: any = null): Observable<Mensagem[]> {
    return this.http.post<Mensagem[]>(this.baseUrl + '/search', obj, { headers: this.headers });
  }
  

  public getPathModule(): string {
    return '/chat-bot/suporte-geral';
  }
}
